import {Analytics} from 'analytics';
import anvilGoogleAnalytics from './custom_plugins/google_analytics';
import facebookPixel from './custom_plugins/facebook_pixel';
import mather from './custom_plugins/mather';
import pageMetaEnricher from './custom_plugins/page_meta_enricher';
import Cookies from 'js-cookie';

let analytics;
let anvilAnalyticsConfig;

anvilAnalyticsConfig = JSON.parse(document.getElementById('analytics-config').textContent);

let plugins = [];

if (!anvilAnalyticsConfig || anvilAnalyticsConfig === {}) {
  console.error('analytics-config empty or undefined');
}

const pageMeta = anvilAnalyticsConfig.page_payload.page_meta;

if ('ga' in anvilAnalyticsConfig) {
    anvilAnalyticsConfig['ga'].forEach(gaConfig => {
    try {
      plugins.push(
        anvilGoogleAnalytics({
          measurementId: gaConfig.id,
          dimensions: gaConfig.dimensions,
          pageMeta,
        })
      );
    } catch (e) {
      console.error(`Google Analytics plugin ${gaConfig.id} not initialized.`);
      console.error(e);
    }
  });
}

if ('fb' in anvilAnalyticsConfig) {
  try {
    plugins.push(
      facebookPixel({
        pixelId: anvilAnalyticsConfig.fb.id,
        identifyPayloadMapping: anvilAnalyticsConfig.fb.identify_payload_mapping,
        pageMeta,
      })
    )
  } catch (e) {
    console.error(`Facebook Pixel plugin ${anvilAnalyticsConfig.fb.id} not initialized.`);
    console.error(e);
  }
}

if ('pinpoint' in anvilAnalyticsConfig) {
  try {
    import(/* webpackChunkName: "pinpointPlugin" */ './custom_plugins/amazon_pinpoint').then(({default: amazonPinpoint}) => {
        const pinpointConfig = anvilAnalyticsConfig.pinpoint;
        plugins.push(
          amazonPinpoint({
            appId: pinpointConfig.app_id,
            identityPoolId: pinpointConfig.identity_pool_id,
            region: pinpointConfig.region,
            pageMeta,
          })
        )
        return null
    }).catch(e => console.error("Could not import amazon pinpoint.", e));
  } catch (e) {
    console.error(`Amazon Pinpoint plugin ${anvilAnalyticsConfig.pinpoint.app_id} not initialized.`);
    console.error(e);
  }
}

if ('mather' in anvilAnalyticsConfig) {
    try {
        const matherConfig = anvilAnalyticsConfig.mather;
        plugins.push(
            mather({
                customerId: matherConfig.customer_id,
                marketId: matherConfig.market_id,
                pageMeta,
            })
        );
    } catch (e) {
        console.error('Mather Listener not initialized');
        console.error(e);
    }
}


analytics = Analytics({
  app: anvilAnalyticsConfig['app'],
  version: anvilAnalyticsConfig['version'],
  debug: anvilAnalyticsConfig['debug'],
  plugins: [
      // Must come first in order to enrich the payload for the other plugins
      pageMetaEnricher,
      ...plugins
  ]
});

// Identify the user, `anvilAnalyticsConfig.identify_payload` contains the traits that should be attached to the user.
analytics.identify(anvilAnalyticsConfig.userId, anvilAnalyticsConfig.identify_payload);

analytics.page(anvilAnalyticsConfig.page_payload);

/**
 * Check to see if the user has just finished the registration wall.
 */
let completedRegistrationWallMethod = Cookies.get("CompleteRegistrationWall");
if ( completedRegistrationWallMethod !== undefined) {
    analytics.track("CompleteRegistrationWall", {
        method: completedRegistrationWallMethod,
    });
    Cookies.remove("CompleteRegistrationWall");
}

export {analytics, anvilAnalyticsConfig};
